import { useWallet } from '@solana/wallet-adapter-react';
import React, { useContext, useEffect, useState } from 'react';
import { AuthorizationContext } from '../../contexts/auth.context';
import { WizardContext } from '../../contexts/story.context';
import { Pages, LEGAL_WALLETS } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';

const IMAGES = [
  'https://i.imgur.com/rq78rvr.png',
  'https://i.imgur.com/fMMZafs.png',
  'https://i.imgur.com/eonJNix.png',
  'https://i.imgur.com/v8CAH5R.png',
];

const COMPANY_LOGO_URL = 'https://d3omtvnlh9xgzy.cloudfront.net/core/coin-default.png';

const bgImg = IMAGES[Math.floor(Math.random() * IMAGES.length)];

const ConnectWalletPrompt = ({ onRequestConnectWallet, loading }) => {
  const wallet = useWallet();
  const isLegalWallet = wallet && LEGAL_WALLETS.includes(wallet.publicKey?.toString());

  React.useEffect(() => {
    const button = document.querySelector('.wallet-adapter-button');
    if (button) {
      button.click();
    }
  }, []);
  return (
    <div className="game-login">
      <div className="game-login-art" aria-hidden="true">
        <div
          className="bg-holder"
          style={{
            backgroundImage: `url("${bgImg}")`,
            backgroundPosition: '50% 30%',
          }}
        />
      </div>
      <div className="game-login-panel">
        <div className="game-login-card">
          <div className="game-micro mb-2">access check</div>
          <img className="game-login-logo" src={COMPANY_LOGO_URL} alt="company logo" />
          <h1 className="game-login-title">Catsaspell</h1>
          <p className="game-login-copy">
            {isLegalWallet
              ? 'Wallet recognized. Enter the operator console.'
              : 'Only approved operator wallets can enter this console.'}
          </p>
          <button
            onClick={onRequestConnectWallet}
            className="wallet-adapter-button wallet-adapter-button-trigger"
            tabIndex={0}
            type="button"
            disabled={!isLegalWallet || loading}
          >
            {loading ? 'Loading...' : isLegalWallet ? 'Enter' : 'Wallet Not Allowed'}
          </button>
        </div>
      </div>
    </div>
  );
};

const SelectionPage = () => {
  const wallet = useWallet();
  const { signIn } = useContext(AuthorizationContext);
  const { dispatch } = useContext(WizardContext);
  const [loading, setLoading] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (wallet) {
      wallet.connect();
    }
  }, [wallet]);

  const selectPage = async character => {
    if (loading) return;

    setLoading(true);
    try {
      await signIn();
      dispatch({ type: 'SET_CHARACTER', character });
      dispatch({ type: 'SET_STEP', step: 2 });
      navigate(character.path);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  };

  return (
    <ConnectWalletPrompt onRequestConnectWallet={() => selectPage(Pages[0])} loading={loading} />
  );
};

export default SelectionPage;
